import { render, staticRenderFns } from "./IssueSystems.vue?vue&type=template&id=795f7562&scoped=true"
import script from "./IssueSystems.vue?vue&type=script&lang=js"
export * from "./IssueSystems.vue?vue&type=script&lang=js"
import style0 from "./IssueSystems.vue?vue&type=style&index=0&id=795f7562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795f7562",
  null
  
)

export default component.exports